
export function makeImportant(str){
    return str + " !important;";
}

